
export default class DataBaseline {
    constructor(elm) {
        if (!window.dataLayer) {
            window.dataLayer = [];
        }

        if (elm.querySelectorAll('form').length) {
            uforms();
        }

        // umbraco forms tracking
        function uformGtmTracking(e) {
            const formName = e.target.FormName.value;
            // check if there are validation errors
            if (elm.getElementsByClassName('dataconsent').length > 0) {
                if (elm.getElementsByClassName('dataconsent')[0].getElementsByTagName('input')[0].checked && !elm.getElementsByClassName('field-validation-error').length) {

                    const templateName = elm.getElementsByClassName('templatename')[0].getElementsByClassName('hidden')[0].value;
                    // let name = formIdNormalized.getElementsByClassName("name")[0].getElementsByClassName("text")[0].value;
                    // pushing which form is submitted
                    window.dataLayer.push({
                        'event': templateName,
                        'formVariant': formName,
                    });
                }
            }
        }

        function uforms() {
            elm.querySelectorAll('form').forEach(uform => {
                uform.onsubmit = uformGtmTracking;

            });
        }
    }
}
